/* eslint-disable max-len */

export default {
  allInOne: {
    requestForm: {
      buttonText: 'Отправить заявку',
      btnWithoutHome: 'Подключить',
      connectHouseLink: 'Сообщить когда подключат мой дом',
      tariffDiscountLabel: 'Тариф со скидкой',
      tariffUnit: '₽/мес',
      regionLabel: 'Город',
      streetLabel: 'Улица',
      homeLabel: 'Дом',
      flatLabel: 'Квартира',
      phoneLabel: 'Номер телефона',
      nameLabel: 'Как к вам обращаться',
      regionIsNotFound: 'К сожалению введенный Вами регион не найден',
      streetIsNotFound: 'К сожалению, введенная Вами улица не найдена',
      houseIsNotFound: 'К сожалению, введенный Вами дом не найден',
      notAvailableHousePrefix: 'По адресу ',
      notAvailableHousePostfix: ' доступно подключение мобильной связи + билайн ТВ без домашнего интернета',
      userAgreementText: 'Нажимая на кнопку «Отправить заявку» или «Подключить», вы предоставляете ПАО «ВымпелКом» согласие на обработку персональных данных',
      termsOfUse: 'ПАО «ВымпелКом» (127083, г. Москва, ул. Восьмого марта, дом 10, строение 14) обрабатывает указанные в форме персональные данные в течение 1 месяца с целью получения консультации путем сбора, записи, систематизации, накопления, хранения, уточнения (обновления, изменения), извлечения, использования, передачи (предоставления, доступа), обезличивания, блокирования, удаления, уничтожения, как с использованием, так и без использования средств автоматизации в соответствии с Политикой «Обработка персональных данных». Отзыв согласия на обработку персональных данных направляется по форме, размещенной на сайте в сети интернет (www.beeline.ru).',
    },
  },
};
